module.exports = __webpack_public_path__ + "static/img/18.61b5470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/yhw/18.jpg
// module id = X2Ej
// module chunks = 1